import { GET_HERO_SECTION, SET_LOADING_HERO_SECTION, SET_PAGINATION_HERO_SECTION } from '../constant';

const initialState = {
  data: [],
  loadingData: false,
  dataPagination: 0,
  totalData: 0,
};

const heroReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADING_HERO_SECTION: {
      return {
        ...state,
        loadingData: action?.payload,
      };
    }
    case SET_PAGINATION_HERO_SECTION: {
      return {
        ...state,
        dataPagination: action?.payload,
      };
    }
    case GET_HERO_SECTION: {
      return {
        ...state,
        data: action?.payload?.data || [],
        totalData: action?.payload?.total,
        loadingData: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default heroReducer;
